export const WINDOW_INTERIOR_FRAME_WIDTH = 3.5;
export const WINDOW_EXTERIOR_FRAME_WIDTH = 3.5;
export const WINDOW_EXTERIOR_FRAME_DEPTH = 0.75;
export const WINDOW_DEFAULT_HEAD_CASING_WIDTH = 3.5;
export const WINDOW_DEFAULT_APRON_CASING_WIDTH = 4;
